export const isObject = (obj: any): boolean => {
  return obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function';
};

export const isObjectEmpty = (obj: any): boolean => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const removeFalsy: any = (obj: object) => {
  if (typeof obj === 'object' && isObject(obj)) {
    return Object.entries(obj)
      .filter(([, v]) => ![undefined, null, ''].includes(v))
      .reduce((r, [key, value]) => ({ ...r, [key]: removeFalsy(value) }), {});
  } else if (Array.isArray(obj)) return obj.map(removeFalsy);
  else return obj;
};

// remove URL from object and use id as value
export const removeURLFromObject = <T extends object>(obj: T): T =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      return { ...acc, [key]: value.map((val) => (val.url ? val.id : val)) };
    }

    return value.url ? { ...acc, [key]: value.id } : { ...acc, [key]: value };
  }, {} as T);

export const hasDuplicates = <T>(array: T[]) => new Set<T>(array).size !== array.length;
